import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import moment from 'moment';
import 'moment-timezone';

// Устанавливаем единую временную зону для фронтенда
moment.tz.setDefault('Asia/Qyzylorda');

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);
